import React from 'react';
import { useTranslation } from 'react-i18next';
import DynamicCrudPage from '../../components/DynamicCrudPage';
import { useCompanies, SCREENS } from '../../hooks';
import AddIcon from '@mui/icons-material/Add';

const CompaniesPage = () => {
  const { t } = useTranslation();

  return (
    <DynamicCrudPage
      entityType="companies"
      screen={SCREENS.COMPANIES}
      hook={useCompanies}
      addButtonTextKey="table.actions.addCompany"
      addButtonIcon={<AddIcon />}
      entityTypeForDataTable="company"
      showAddButton={true}
    />
  );
};

export default CompaniesPage;
